module.exports = "<app-notes-list [notes]=archiveList (anyChanges)=\"refresh($event)\"></app-notes-list>"